import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { CustomerService } from '../../../api/gen/api/customer.service';
import { CustomerDto } from '../../../api/gen/model/customerDto';
import { JjamesButtonComponent, JJamesCardComponent, ResponsiveBaseComponent } from 'shared-lib';

@Component({
    selector: 'app-customer-list',
    standalone: true,
    imports: [
        CommonModule,
        JjamesButtonComponent,
        JJamesCardComponent
    ],
    templateUrl: './customer-list.component.html',
    styleUrls: ['./customer-list.component.scss']
})
export class CustomerListComponent extends ResponsiveBaseComponent implements OnInit {
    private readonly customerService = inject(CustomerService);
    private readonly router = inject(Router);

    customers = signal<CustomerDto[]>([]);
    loading = signal(false);
    errorMessage = signal<string | null>(null);

    ngOnInit(): void {
        this.loadCustomers();
    }

    loadCustomers(): void {
        this.loading.set(true);
        this.errorMessage.set(null);

        this.customerService.customerFilterPost(undefined, false, 0, 100).subscribe({
            next: (response) => {
                if (response) {
                    this.customers.set(response.items ?? []);
                }
                this.loading.set(false);
            },
            error: (error) => {
                console.error('Error loading customers:', error);
                this.errorMessage.set('An error occurred while loading customers');
                this.loading.set(false);
            }
        });
    }

    createCustomer(): void {
        this.router.navigate(['/customer-management/create']);
    }

    viewCustomer(customerId: string): void {
        this.router.navigate(['/customer-management', customerId]);
    }
}
